import {DTProductSelectionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {productCardSchema} from '../../../../../schemas/productCardSchema';
import {z} from 'zod';

export function convertProductAPICardToAICard(productCard: DTProductSelectionNode) {
  const card: z.input<typeof productCardSchema> = {
    ...productCard,
    cardId: productCard.id,
    name: productCard.name ?? '',
    description: productCard.description ?? '',
    productsSelectionStrategy: productCard.productsSelectionStrategy,
    conditions:
      productCard.configuration?.conditions?.map((condition) => ({
        feedColumnSignalKey: condition.feedColumnSignalKey,
        operator: condition.operator,
        signalKey: condition.signalKey,
        feedKey: condition.feedKey ?? 0,
      })) ?? [],
    productIds: productCard.productIds ?? [],
  } satisfies z.output<typeof productCardSchema>;

  return card;
}
